// #162870

// rgba(225, 245, 255, 1)

import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useToolbarContainerStyles = makeThemedStyles(
  "ToolbarContainer",
  (theme) => ({
    root: {
      width: "100%",
      color: "white",
      background: "#162870",
      minHeight: "71px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  })
);

const ToolbarContainer = (props: React.PropsWithChildren<{}>) => {
  const styles = useToolbarContainerStyles();
  return <div className={styles.root}>{props.children}</div>;
};

export default ToolbarContainer;
